import React from "react";

const TooltipInput = ({ type, id, placeholder, tooltip, value, onChange }) => {
    return (
        <div className="input-container">
            <input
                type={type}
                id={id}
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                required
                onFocus={(e) => e.target.nextSibling.classList.add("visible")}
                onBlur={(e) => e.target.nextSibling.classList.remove("visible")}
            />
            <span className="tooltip">{tooltip}</span>
        </div>
    );
};

export default TooltipInput;
